import styled from "@emotion/styled";
import { AddRounded, DeleteRounded } from "@mui/icons-material";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { deleteTableColumn } from "data/globalData";
import { attrGroupLinkedTables, attrGrpTableStrColumnsObj, constraintsOptions, isColumnDefault } from "components/PimDashboard/data";
import { GlobalState } from "context/GlobalContext";
import { useEffect, useState } from "react";
import { attrGrpAttrAssocObj, attrValAssocObj } from "../../DesignerAttributes/data";
import { PimDashboardState } from "context/PimDashboardContext";
import { getColDefaultValue } from "components/PimDashboard/data";
import RenderInputField from "components/PimDashboard/CommonComponents/RenderInputField/RenderInputField";
import { DataGrid } from "@mui/x-data-grid";
import { isNew } from "../data";
import { removeDropdownOptionsBasedonDependency } from "../RenderAttributes/RenderAttributeInputs";

const VisuallyHiddenInput = styled("input")({
	clip: "rect(0 0 0 0)",
	clipPath: "inset(50%)",
	height: 1,
	overflow: "hidden",
	position: "absolute",
	bottom: 0,
	left: 0,
	whiteSpace: "nowrap",
	width: 1,
});
export const TableImgComponent = ({ data, column }) => {
	return (
		<Box width="100%" height="100%" display="flex" justifyContent="center" alignItems="center">
			<Box
				component="label"
				width="45px"
				height="55px"
				border={`1px solid ${grey[200]}`}
				display="flex"
				alignItems="center"
				justifyContent="center"
				overflow="hidden"
				position="relative">
				<img src={data?.[column]} style={{ width: "100%", position: "absolute" }} />
			</Box>
		</Box>
	);
};

const ColorsSection = ({ colors, setColors, styleData }) => {
	const [newColor, setNewColor] = useState();
	const { attrGroupsWithAttr, allAttributes } = PimDashboardState();
	const [colorTableColumns, setColorTableColumns] = useState();
	console.log(colorTableColumns, "colorTableColumnscolorTableColumns");
	useEffect(() => {
		let colorAttrs = [];
		Object.keys(attrGroupsWithAttr).forEach((grpId) => {
			if (attrGroupsWithAttr[grpId][attrGrpTableStrColumnsObj.linked_table.key] === attrGroupLinkedTables.color.key)
				colorAttrs = attrGroupsWithAttr[grpId][attrGrpAttrAssocObj];
		});
		setColorTableColumns(colorAttrs?.length ? colorAttrs : []);
		setNewColor(
			colorAttrs?.reduce((acc, row) => {
				acc[row.key] = getColDefaultValue(row);
				return acc;
			}, {})
		);
	}, [attrGroupsWithAttr]);
	const { setSnackBarOpen, setSnackBar, snackBar } = GlobalState();

	const handleAddColorClick = () => {
		// console.log(attributesWithValues?.filter((row) => row.key === "newColor"));
		let count = [];
		allAttributes?.forEach((row) => {
			if (
				row.linked_table === attrGroupLinkedTables.color.key &&
				row?.constraints?.[constraintsOptions.NOTNULL.key] &&
				isColumnDefault(row, newColor?.[row.key])
			)
				count.push(row);
		});
		if (count.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Missing required fields: ${count.map((row) => row.name)}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			return;
		}
		const isPresent = colors.reduce((acc, row) => {
			count = 0;
			allAttributes?.forEach((clrCol) => {
				if (clrCol.linked_table === attrGroupLinkedTables.color.key && newColor[clrCol.key] === row[clrCol.key]) count++;
			});
			if (count === colorTableColumns?.length) acc.push(row);
			return acc;
		}, []);

		if (isPresent.length > 0) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Color is already present",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			return;
		}
		setColors([...colors, { ...newColor, id: new Date().valueOf(), [isNew]: true }]);
		setNewColor(
			colorTableColumns?.reduce((acc, row) => {
				acc[row.key] = getColDefaultValue(row);
				return acc;
			}, {})
		);
	};
	const handleColorDelete = (color) => {
		setColors(colors.filter((row) => !(row?.id === color?.id && row.pallete === color.pallete)));
	};

	return (
		<Box display="flex" flexWrap="wrap" width="100%" rowGap={1} justifyContent="space-around">
			<Box height={320} width="58%">
				<Typography variant="h6" width="100%">
					Colors
				</Typography>
				{colorTableColumns?.length >= 0 && (
					<DataGrid
						rows={colors ? colors : []}
						columns={[
							{
								headerName: "Image",
								field: "img",
								minWidth: 120,
								headerAlign: "center",
								flex: 1,
								renderCell: ({ row }) => {
									return <TableImgComponent data={row} column="url" />;
								},
							},
							...colorTableColumns?.map((colorCol) => {
								return {
									field: colorCol?.key,
									headerName: colorCol?.name?.toUpperCase(),
									minWidth: 130,
									headerAlign: "center",
									align: "center",
									flex: 1,
								};
							}),
							deleteTableColumn(handleColorDelete),
						]}
						sx={{
							minHeight: 290,
							maxHeight: 290,
							// width: "95%",
							"& .MuiDataGrid-row": {
								borderBottom: "1px solid lightgray",
								cursor: "pointer",
							},
							"& .MuiDataGrid-columnHeader": {
								cursor: "pointer",
								// background: grey[300],
								borderRight: "1px solid lightgray",
							},
						}}
						columnHeaderHeight={35}
						rowHeight={60}
						disableRowSelectionOnClick
						pageSizeOptions={[5, 10]}
						hideFooter
						pagination={false}
						disableAutosize
					/>
				)}
			</Box>

			{/* Add Color */}
			<Box width="38%">
				<Typography variant="h6" width="100%">
					Add Color
				</Typography>
				<Stack
					spacing={1}
					component="form"
					borderRadius={1}
					border={`1px solid ${grey[300]}`}
					sx={{ overflowY: "scroll", padding: "2%", minHeight: 275, maxHeight: 275 }}>
					<Box
						component="label"
						width="80px"
						height="90px"
						border={`1px solid ${grey[200]}`}
						display="flex"
						alignItems="center"
						justifyContent="center"
						overflow="hidden"
						position="relative">
						{newColor?.url ? <img src={newColor.url} style={{ width: "100%", position: "absolute" }} /> : <AddRounded />}

						<VisuallyHiddenInput
							type="file"
							onChange={(e) => {
								const file = e.target.files[0];
								if (file) {
									const reader = new FileReader();
									reader.onload = (event) => {
										console.log(event.target.result, "jashkgdvjsaxick");
										setNewColor({
											...newColor,
											file: file,
											url: event.target.result, // This will be the data URL
										});
									};
									reader.readAsDataURL(file);
								}
							}}
						/>
					</Box>

					{colorTableColumns?.map((column) => {
						let options = {};
						options = removeDropdownOptionsBasedonDependency(column, styleData, column?.[attrValAssocObj], allAttributes);

						return (
							<RenderInputField
								column={{ ...column, options }}
								data={newColor}
								setData={setNewColor}
								selectOptObjName={"options"}
								width={"100%"}
								// dependencyColData={}
							/>
						);
					})}
					<Box>
						<Button variant="contained" onClick={handleAddColorClick}>
							Add Color
						</Button>
					</Box>
				</Stack>
			</Box>
		</Box>
	);
};

export default ColorsSection;
